import useResource from 'app/hooks/useResource';

import {
  jobs as resource
} from 'app/resources';

import {
  getJobs,
  setJobParams
} from 'app/actions/jobs';

import {
  createJob,
  updateJob,
  destroyJobs
} from 'app/services/jobs';

const useJobs = () => {
  const formatQuickEditParams = params => {
    // process params as needed
    if (Object.keys(params).includes('kiosk')) {
      params.kiosk_id = params.kiosk;
      delete params.kiosk;
    }
    return params;
  }

  return useResource({
    resource,
    getResource: getJobs,
    createResource: createJob,
    updateResource: updateJob,
    destroyResource: destroyJobs,
    setResourceParams: setJobParams,
    formatQuickEditParams
  });
}

export default useJobs;
